import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import { ensureCurrentUser, ensureUser } from '../../util/data';
import { withViewport } from '../../util/contextHelpers';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  AvatarLarge,
  AvatarMedium,
  ExternalLink,
  NamedLink,
  VideoEmbed,
  PageBootstrap,
} from '../../components';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { TopbarContainer, NotFoundPage } from '../../containers';
import config from '../../config';
import SectionListings from '../LandingPage/SectionListings';
import { findOptionsForSelectFilter } from '../../util/search';

import Lightbox from 'react-image-lightbox';
import { richText } from '../../util/richText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faYoutube, faInstagram, faFacebook } from "@fortawesome/free-brands-svg-icons";

import "./ProfilePage.scss"

import { faCirclePlay } from "@fortawesome/pro-regular-svg-icons"



import { toImgixLarge } from '../../util/imgix';



export class ProfilePageComponent extends Component {
  constructor(props) {
    super(props);
    this.updateGalleryHeight = this.updateGalleryHeight.bind(this);
    this.state = {
      imageCarouselOpen: false,
      isLightBoxOpen: false,
      photoIndex: 0,
      scrollPosition: 0,
      galleryHeight: 0,
    };

    

  }
  updateGalleryHeight = () => {
   
    const imageElement = document.querySelector('.fullHeightImage');

    if (imageElement) {
      this.setState({ galleryHeight: imageElement.offsetHeight });
    }
  }


  componentDidMount() {
    if (typeof window !== 'undefined') {
      require('react-image-lightbox/style.css');
    }
    window.addEventListener('scroll', this.handleScroll);
    this.updateGalleryHeight();
    window.addEventListener('resize', this.updateGalleryHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateGalleryHeight);

  }

  handleScroll = () => {
    if (typeof window !== 'undefined') {
      const position = window.pageYOffset;
      this.setState({ scrollPosition: position });
    }
  };
  //scroll position setting

  render() {
    const {
      scrollingDisabled,
      currentUser,
      user,
      userShowError,
      queryListingsError,
      listings,
      viewport,
      intl,
    } = this.props;
   

    const innerWidth = () => {
      if (typeof window !== 'undefined') {
        return window.innerWidth
      }
    }

    const lightText = innerWidth() > 650 ? this.state.scrollPosition < 650 : this.state.scrollPosition < innerWidth();
    const ensuredCurrentUser = ensureCurrentUser(currentUser);
    const profileUser = ensureUser(user);
    const isCurrentUser =
      ensuredCurrentUser.id && profileUser.id && ensuredCurrentUser.id.uuid === profileUser.id.uuid;
    const displayName = profileUser.attributes.profile.displayName;
    const bio = profileUser.attributes.profile.bio;
    const hasBio = !!bio;
    const hasListings = listings.length > 0;

   
   

    const profileHeadline = profileUser && profileUser.attributes.profile.publicData?.profileHeader;
    const message = profileUser && profileUser.attributes.profile.publicData?.message;
    const highlights = profileUser && profileUser.attributes.profile.publicData?.highlights;
    const instagram = profileUser && profileUser.attributes.profile.publicData?.instagram;
    const facebook = profileUser && profileUser.attributes.profile.publicData?.facebook;
    const twitter = profileUser && profileUser.attributes.profile.publicData?.twitter;


    const qa = profileUser && profileUser.attributes.profile.publicData?.qa;
    const youtubeLink = profileUser && profileUser.attributes.profile?.publicData?.youtubeLink;

    const filterConfig = config.custom.filters;
    const activitiesOptions = findOptionsForSelectFilter('activities', filterConfig);

    const firstListing = hasListings && listings[0];
    const activities = firstListing && firstListing.attributes.publicData?.activities;

    const openMediaButtonMessage = intl.formatMessage({
      id: 'ListingPage.openMediaButtonMessage',
    });

    const { isLightBoxOpen, photoIndex } = this.state;
    const extraImages = profileUser?.attributes?.profile?.publicData?.extraImages ?? [];
    const imagesArray = [...extraImages].map(toImgixLarge);
    const facebookImages = imagesArray.map(i => {
      return { url: i, width: 1200, height: 630 };
    });
    const twitterImages = facebookImages;
    const schemaImages = JSON.stringify(imagesArray);

    //TODO validate and fix this
    const formatLink = link => {
      if (!link.includes('https://') && link.includes('www.')) {
        return 'https://' + link;
      }
      if (!link.includes('https://') && !link.includes('www.')) {
        return 'https://' + 'www.' + link;
      }

      return link;
    };
    const schemaTitle = intl.formatMessage(
      {
        id: 'ProfilePage.schemaTitle',
      },
      {
        name: displayName,
        siteTitle: config.siteTitle,
      }
    );
    const mainContent = (
      <PageBootstrap
        description={profileHeadline}
        title={schemaTitle}
        facebookImages={facebookImages}
        twitterImages={twitterImages}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'Website',
          description: profileHeadline,
          name: schemaTitle,
          image: schemaImages,
        }}
      >
        {isLightBoxOpen && (
          <Lightbox
            mainSrc={imagesArray[photoIndex]}
            nextSrc={imagesArray[(photoIndex + 1) % imagesArray.length]}
            prevSrc={imagesArray[(photoIndex + imagesArray.length - 1) % imagesArray.length]}
            onCloseRequest={() => this.setState({ isLightBoxOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + imagesArray.length - 1) % imagesArray.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % imagesArray.length,
              })
            }
          />
        )}
        <nav className="secondbar">
          <Row className="inner d-flex flex-row">
            <Col lg="auto" md="auto" sm="auto" xs="auto">
              <p className="page-title align-items-center justify-content-start">
                Guides
              </p>
            </Col>
          </Row>
        </nav>

        <Container fluid className="content_profile">
          <Row className="hero">
    
              <Col lg={8} md={8} sm={8} xs={12} className="herorow">
                <img 
                className="fullHeightImage"
                onLoad={this.updateGalleryHeight} 
                src={imagesArray[0]} 
                loading="lazy" />
              </Col>
              <Col lg={4} md={4} sm={4} xs={12} className="halfrow">
                <img className="halfHeightImage" src={imagesArray[1]} loading="lazy" />
                <img className="halfHeightImage" src={imagesArray[2]} loading="lazy" />
              </Col>
       
          </Row>
           
      
          <div className="openGallery d-flex align-items-center justify-content-center"
            style={{ height: this.state.galleryHeight }}
>
            <a onClick={() => this.setState({ isLightBoxOpen: true })} className="openGalleryLink d-flex align-items-center">
              <FontAwesomeIcon icon={faCirclePlay} className="me-2 icon-baseline-adjust" />
              {openMediaButtonMessage}
            </a>
          </div>


           

            <div className="titleWrapper-profile">
              <Row className="titleSection-profile">
                <Col lg="auto" md="auto" sm="auto" xs="auto" >
                <div><AvatarLarge className="avatar" user={user} disableProfileLink /></div>
                </Col>
                <Col lg="auto" md="auto" sm="auto" xs="auto" >
                  <div className="guidNameAndHeadline">
                    <h1 className="profileTitle">{displayName}</h1>
                    {profileHeadline && <p className="profileHeadline">{profileHeadline}</p>}
                  </div>
                </Col>
              </Row>
            </div>
        </Container>


        <Container fluid className="topContentWrapper">
          <Row className="contentSection">
            <Col lg={8} md={8} sm={12} xs={12} className="mainColumnRight">
              {bio ? (
                <div className="bodyBlock">
                  <h2 className="sectionTitle">
                    <FormattedMessage id="ProfilePage.bio" />
                  </h2>
                  <p className="lineBreak">
                    {richText(bio, {
                      longWordClass: "sectionDescription",
                    })}
                  </p>
                </div>
              ) : (
                <div className="bodyBlock">
                  <h2 className="sectionTitle">
                    <FormattedMessage id="ProfilePage.bio" />
                  </h2>
                  <p className="sectionDescription">
                    <FormattedMessage id="ProfilePage.noInfo" />
                  </p>
                </div>
              )
              }

              {
                youtubeLink && <VideoEmbed className="video" videoUrl={youtubeLink} />
              }

            

              {
                message ? (
                  <div className="bodyBlock">
                    <h2 className="sectionTitle">
                      <FormattedMessage id="ProfilePage.message" />
                    </h2>
                    <p className="lineBreak">
                      {richText(message, {
                        longWordClass: "sectionDescription",
                      })}
                    </p>
                  </div>
                ) : (
                  <div className="bodyBlock">
                    <h2 className="sectionTitle">
                      <FormattedMessage id="ProfilePage.message" />
                    </h2>
                    <p>
                      <FormattedMessage id="ProfilePage.noInfo" />
                    </p>
                  </div>
                )
              }

              {
                qa ? (
                  <div className="bodyBlock">
                    <h2 className="sectionTitle">
                      <FormattedMessage id="ProfilePage.qa" />
                    </h2>

                    {qa.map(q => {
                      return (
                        <div key={q.question} className="qaDescription">
                          <p className="qaQuestion">Q: {q.question}</p>
                          <p className="sectionDescription">{q.answer}</p>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="bodyBlock">
                    <h2 className="sectionTitle">
                      <FormattedMessage id="ProfilePage.qa" />
                    </h2>
                    <p className="sectionDescription">
                      <FormattedMessage id="ProfilePage.noInfo" />
                    </p>
                  </div>
                )
              }
            </Col>
         
            <Col lg={4} md={4} sm={12} xs={12} className="mainColumnLeft">
              <div className="bodyBlock">
              
                  <h2 className="sectionTitle">
                    <FormattedMessage id="ProfilePage.highlights" />
                  </h2>
                  <p className="lineBreak">
                    {highlights ? (
                      richText(highlights, {
                        longWordClass: "sectionDescription",
                      })
                    ) : (
                      <FormattedMessage id="ProfilePage.noInfo" />
                    )}
                  </p>

                  {instagram && (
                    <ExternalLink href={formatLink(instagram)} className="socialIconWrapper">
                      <FontAwesomeIcon icon={faInstagram} className="socialIconLeft"></FontAwesomeIcon>
                      <p className="socialIconRight">Instagram</p>
                    </ExternalLink>

                  )}
                  {facebook && (
                    <ExternalLink href={formatLink(facebook)} className="socialIconWrapper">
                      <FontAwesomeIcon icon={faFacebook} className="socialIconLeft"></FontAwesomeIcon>
                      <p className="socialIconRight">Facebook</p>
                    </ExternalLink>
                  )}
                  {twitter && (
                    <ExternalLink href={formatLink(twitter)} className="socialIconWrapper">
                      <FontAwesomeIcon icon={faTwitter} className="socialIconLeft"></FontAwesomeIcon>
                      <p className="socialIconRight">Twitter</p>
                    </ExternalLink>
                  )}
              </div>
          </Col>
            <Col className="bodyWrapper">
              <div className="bodyBlock">
                {profileUser?.id ? (
                  <SectionListings listings={listings} titleClassName="experience_title" />
                ) : null}
              </div>
            </Col>
          </Row>
        
        </Container>
 
    
      </PageBootstrap >
    );

    let content;

    if (userShowError && userShowError.status === 404) {
      return <NotFoundPage />;
    } else if (userShowError || queryListingsError) {
      content = (
        <p className="error">
          <FormattedMessage id="ProfilePage.loadingDataFailed" />
        </p>
      );
    } else {
      content = mainContent;
    }

    return (
      <Page
        scrollingDisabled={scrollingDisabled}
        title={schemaTitle}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'ProfilePage',
          name: schemaTitle,
        }}
      >
        <LayoutSideNavigation>
          <LayoutWrapperTopbar>
            <TopbarContainer currentPage="ProfilePage" bigText={'Guides'} lightText={lightText} />
          </LayoutWrapperTopbar>

          <LayoutWrapperMain className="pageWrapper">{content}</LayoutWrapperMain>

          <LayoutWrapperFooter>
            <Footer showBanner={false} />
          </LayoutWrapperFooter>
        </LayoutSideNavigation>
      </Page>
    );
  }
}

ProfilePageComponent.defaultProps = {
  currentUser: null,
  user: null,
  userShowError: null,
  queryListingsError: null,
};

const { bool, arrayOf, number, shape } = PropTypes;

ProfilePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  currentUser: propTypes.currentUser,
  user: propTypes.user,
  userShowError: propTypes.error,
  queryListingsError: propTypes.error,
  listings: arrayOf(propTypes.listing).isRequired,

  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    userId,
    userShowError,
    queryListingsError,
    userListingRefs,
  } = state.ProfilePage;

  const userMatches = getMarketplaceEntities(state, [{ type: 'user', id: userId }]);
  const user = userMatches.length === 1 ? userMatches[0] : null;
  const listings = getMarketplaceEntities(state, userListingRefs);
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    user,
    userShowError,
    queryListingsError,
    listings,
  };
};

const ProfilePage = compose(
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(ProfilePageComponent);

export default ProfilePage;